import React from "react";
import { Button, Modal } from "@mui/material";

interface DeleteModalProps<T> {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (section: T) => void; // Update the onConfirm callback to accept a section
  title: string;
  message: string;
  section: T; // Add the section prop to accept the section object
}

const DeleteModal = <T,>({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  section,
}: DeleteModalProps<T>) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2/3
      md:w-1/3 max-w-screen-md bg-white shadow-lg p-5 rounded-lg"
      >
        <h2 className="text-lg md:text-xl font-semibold  text-primary">
          {title}
        </h2>
        <p className="text-base font-semibold mt-2">{message}</p>
        <div className="flex justify-between items-center mt-4">
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{ border: `1px solid primary`, textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => onConfirm(section)}
            variant="contained"
            sx={{ color: "white", textTransform: "none" }}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
